// Turks (tr-TR), email: zelfde vorm als email.nl.ts. Wat ontbreekt valt terug op het Nederlands.
// Paden in de app ({origin}/instellingen/...) blijven zoals ze zijn: dat zijn de echte adressen.
export const emailTr = {
    buttonFallback: 'Düğme çalışmıyor mu? Bu bağlantıyı kopyala: {url}',
    verify: {
        subject: '{product} için e-posta adresini onayla',
        lines: [
            'Hoş geldin! Aile panonu kullanabilmek için e-posta adresini onayla.',
            'Bu bağlantı 24 saat geçerli. Hesap oluşturmadıysan bu e-postayı dikkate alma.',
        ],
        cta: 'E-posta adresini onayla',
    },
    reset: {
        subject: 'Şifreni yeniden belirle',
        lines: [
            'Yeni bir şifre istedin.',
            'Bu bağlantı 60 dakika geçerli ve bir kez çalışır. Bunu sen istemediysen bu e-postayı dikkate alma; şifren değişmeden kalır.',
        ],
        cta: 'Yeni şifre seç',
    },
    invitation: {
        subject: 'Aile panosuna davet: {household}',
        lines: ['Bu aile panosuna katılmaya davet edildin: {household}.', 'Davet 7 gün geçerli.'],
        cta: 'Daveti kabul et',
    },
    // Golf 8 (0050): uitnodiging voor de familiekring. Geen woorden over gezondheid; wel dat het
    // geen alarmdienst is.
    // Golf 8 ronde 1 (ON-3): een huisgenoot uitnodigen (rol parent).
    houseInvite: {
        subject: '{inviter} sizi {household} evine davet ediyor',
        lines: [
            '{inviter} sizi AMUMIN’de {household} evine davet ediyor: nöbet çizelgesi, akşam yemeğine kimin geleceği, rezervasyonlar ve ortak masraflar, kendi telefonunuzda.',
            'Ev arkadaşları {inviter} ile aynı haklara sahip olur.',
            'Davet 7 gün geçerlidir.',
        ],
        cta: 'Daveti görüntüle',
    },
    circleInvite: {
        subject: '{inviter} sizi takip etmeye davet ediyor',
        lines: [
            '{inviter} sizi {household} aile panosunu "{label}" olarak takip etmeye davet ediyor.',
            '{name} bunun uygun olup olmadığını panoda kendisi söyler. Sonrasında yalnızca onun onayladıklarını görürsünüz.',
            'Bu bir acil durum servisi değildir.',
            'Davet 7 gün geçerlidir.',
        ],
        cta: 'Daveti görüntüle',
    },
    existingAccount: {
        subject: 'Zaten bir {product} hesabın var',
        lines: [
            'Biri bu e-posta adresiyle yeni bir hesap oluşturmaya çalıştı, ama zaten bir hesap var.',
            'Bu sen miydin? O zaman normal şekilde giriş yap. Şifreni mi unuttun? Aşağıdaki düğmeden yeni bir şifre iste.',
            'Sen değil miydin? O zaman bir şey yapmana gerek yok; hiçbir şey değişmedi.',
        ],
        cta: 'Giriş yap',
    },
    newLogin: {
        subject: '{product} hesabında yeni giriş',
        lines: [
            '{when} tarihinde henüz tanımadığımız bir tarayıcıdan giriş yapıldı.',
            'Bu sen miydin? O zaman bir şey yapmana gerek yok.',
            'Sen değil miydin? O zaman şifreni değiştir ve {origin}/instellingen/beveiliging adresinden her yerde çıkış yap.',
        ],
    },
    devicePaired: {
        subject: '"{device}" tableti bağlandı: {room}',
        lines: [
            '{when} tarihinde "{device}" tableti aile panondaki şu odaya bağlandı: {room}.',
            'Bunu sen mi yaptın, yoksa eşin mi? O zaman bir şey yapmana gerek yok.',
            'Bunu tanımıyor musun? O zaman {origin}/apparaten adresinden bağlantıyı kes ve şifreni değiştir.',
        ],
    },
    loginCode: {
        subject: '{product} kodun: {code}',
        code: 'Kodun: {code}',
        whyNetwork: 'Bir ağı güvenilir olarak eklemek istiyorsun. Onaylamak için bu kodu gir.',
        whyLogin: 'Şifrenle giriş yapıldı. Bu kodu aynı tarayıcıda gir; onaydan sonra o tarayıcıya 30 gün güveniriz ({until} tarihine kadar).',
        details: 'Tarayıcı: {browser} · ağ: {network} · {when}.',
        unknown: 'bilinmiyor',
        validity: 'Kod 10 dakika geçerli.',
        warning: 'Bu kodu asla telefonla, sohbette ya da e-postayla istemeyiz; onu sadece {host} adresinde gir.',
        cta: 'Bu ben değildim',
    },
    trustedBrowser: {
        subject: '{product} için yeni güvenilir tarayıcı',
        someBrowser: 'Bir tarayıcı',
        lines: [
            '{browser} artık güvenilir bir tarayıcı, {until} tarihine kadar geçerli.',
            'O tarayıcıda o zamana kadar e-posta kodu istemeyiz; şifren her zaman gerekli.',
            'Sen değil miydin? O zaman şifreni değiştir ve {origin}/instellingen/beveiliging adresinden tüm tarayıcıları unut.',
        ],
    },
    trustedNetwork: {
        subject: '{label}: {verb} ({name})',
        verbs: {
            added: 'güvenilir ağ olarak eklendi (henüz onaylanmadı)',
            confirmed: 'güvenilir ağ olarak onaylandı',
            updated: 'değiştirildi',
            disabled: 'güvenilir ağ olarak kapatıldı',
            removed: 'güvenilir ağlardan kaldırıldı',
        },
        household: 'Bu, ailedeki tüm ebeveynler için geçerli: bu ağdan girişte şifreden sonra e-posta kodu istemeyiz.',
        identity: 'Bu sadece şu kişi için geçerli: {name}.',
        check: 'Bu doğru değil mi? Güvenilir ağlara {origin}/instellingen/beveiliging adresinden bak.',
    },
    lockout: {
        subject: 'E-posta koduyla giriş geçici olarak engellendi',
        lines: [
            'Çok fazla giriş kodu istendi ya da yanlış girildi. {until} tarihine kadar yeni kod göndermiyoruz.',
            'Sen değil miydin? O zaman şifreni başka biri biliyor olabilir: "Şifremi unuttum" ile değiştir.',
        ],
    },
    wanChanged: {
        subject: 'Sunucunun internet adresi değişti',
        lines: [
            '{when} tarihinde sunucu, internet sağlayıcından yeni bir internet adresi aldı.',
            '"Ev (WAN)" güvenilir ağı bunu kendiliğinden takip eder. Bunu beklemiyor muydun? Modemini ve güvenilir ağları kontrol et.',
        ],
    },
    recoveryReuse: {
        subject: 'Dikkat: "{device}" tableti şüpheli olarak işaretlendi',
        lines: [
            '"{device}" tabletinin kurtarma anahtarı ikinci kez kullanıldı.',
            'Tablet geçici olarak şüpheli olarak işaretlendi. Uygulamada Tabletler bölümünde her şeyin doğru olup olmadığını kontrol et ve bağlantıyı onayla ya da kes.',
        ],
    },
    familyLink: {
        subject: '{name} aile panonla bağlantı kurmak istiyor',
        lines: [
            '{name} doğum günleri ve dilek listeleri gibi birkaç şeyi seninle paylaşmak istiyor.',
            'Sonra karşılığında neyi paylaşacağını kendin seçersin. Davet 7 gün geçerli.',
            'Henüz {product} yok mu? O zaman önce bu e-posta adresiyle ücretsiz bir hesap oluştur.',
        ],
        cta: 'Bağlantıya göz at',
    },
    billing: {
        signupCode: {
            subject: '{code}, kaydını tamamlama kodun',
            lines: [
                '{product} uygulamasına hoş geldin! Kodun: {code}.',
                'Kodu kayıt olduğun ekrana yaz ya da aynı tarayıcıda aşağıdaki düğmeyi kullan.',
                'Kod 10 dakika, düğme 24 saat geçerlidir. Kayıt olmadın mı? Bu e-postayı dikkate alma; hiçbir şey olmaz.',
                'Bu kodu asla telefon, sohbet veya e-posta ile istemeyiz; yalnızca {host} adresinde gir.',
            ],
            cta: 'Kaydı tamamla',
        },
        priceLine: 'Sonrasında ücreti {price}. İstediğin zaman iptal edebilirsin.',
        priceUnknown: 'Sonrasında ne kadar tutacağını süre bitmeden epey önce bildireceğiz. İstediğin zaman iptal edebilirsin.',
        perMonth: 'aylık {amount}',
        trialWelcome: {
            subject: 'Hoş geldin! Deneme ayın {date} tarihine kadar sürüyor',
            lines: [
                '{product} kullandığınız için teşekkürler. İlk ay {date} tarihi dahil ücretsiz.',
                'Şimdi hiçbir şey ödemen veya doldurman gerekmiyor. Bitimden bir hafta önce hatırlatma göndereceğiz.',
            ],
            cta: 'Uygulamaya git',
        },
        trialReminder7d: {
            subject: 'Bir hafta daha ücretsiz: deneme ayın {date} tarihine kadar sürüyor',
            lines: [
                '{product} deneme ayın {date} tarihine kadar sürüyor.',
                'Sonrasında devam etmek ister misin? Ödeme bilgilerini Ayarlar › Abonelik bölümünde ekle.',
                'Hiçbir şey yapmazsan her şeyi görmeye devam edersin ama artık ekleme veya değişiklik yapamazsın. Hiçbir şey silmeyiz.',
            ],
            cta: 'Aboneliği görüntüle',
        },
        trialReminder1d: {
            subject: 'Bugün son ücretsiz günün',
            lines: [
                'Bugün ({date}) {product} ücretsiz ayının son günü.',
                'Kesintisiz devam etmek ister misin? Ödeme bilgilerini bugün Ayarlar › Abonelik bölümünde ekle.',
                'Hiçbir şey yapmazsan pano yarın yalnızca görüntüleme moduna geçer. Verilerin saklanır.',
            ],
            cta: 'Ödeme bilgilerini ekle',
        },
        trialExpired: {
            subject: 'Deneme ayın sona erdi',
            lines: [
                '{product} ücretsiz ayın sona erdi. Her şey yerinde: takvimi ve diğer her şeyi panoda da görebilirsin.',
                'Ödeme bilgilerini ekler eklemez yeniden ekleme ve değişiklik yapabilirsin.',
                'Bırakmak mı istiyorsun? Hiçbir şey yapmana gerek yok. Verilerini asla kendiliğinden silmeyiz; silmek için Ayarlar › Verilerin bölümüne git.',
            ],
            cta: 'Aboneliği görüntüle',
        },
        expiredFollowup: {
            subject: '{product} ile devam etmek ister misiniz?',
            lines: [
                'Deneme ayınız bir ay önce sona erdi. Pano hâlâ yalnızca görüntüleme modunda.',
                'Her zaman devam edebilirsiniz: ödeme bilgilerini Ayarlar › Abonelik bölümünde ekleyin.',
                'Bırakmayı mı tercih edersiniz? Aboneliği iptal edin veya aile panosunu Ayarlar › Verilerin bölümünden silin. Bu konuda bir daha e-posta göndermeyeceğiz.',
            ],
            cta: 'Aboneliği görüntüle',
        },
        cancelled: {
            subject: 'Aboneliğin iptal edildi',
            lines: [
                '{product} aboneliğini iptal ettin. {date} tarihine kadar her şey şimdiki gibi çalışır.',
                'Sonrasında her şeyi görebilirsin ama artık değişiklik yapamazsın. Hiçbir şeyi kendiliğinden silmeyiz.',
                'Fikrini mi değiştirdin? {date} tarihine kadar Ayarlar › Abonelik bölümünden devam edebilirsin.',
            ],
            cta: 'Aboneliği görüntüle',
        },
    },
};
//# sourceMappingURL=email.tr.js.map